// assets/optimize.js
// ------------------------------------------------------
// Impact Theme Performance Patch (Balanced mode)
// - Throttle scroll / resize / move events
// - Làm nhẹ ResizeObserver & IntersectionObserver
// - Không tắt animation, không đụng vào tracking
// ------------------------------------------------------
(function () {
  if (window.__recklessOptimizeApplied) return;
  window.__recklessOptimizeApplied = true;

  // ---- Small helpers -------------------------------------------------------
  function now() {
    return (window.performance && performance.now) ? performance.now() : Date.now();
  }

  function throttle(fn, delay) {
    var last = 0;
    var timer = null;
    var lastArgs, lastThis;

    return function () {
      lastArgs = arguments;
      lastThis = this;
      var t = now();
      var remaining = delay - (t - last);

      if (remaining <= 0 || remaining > delay) {
        if (timer) {
          clearTimeout(timer);
          timer = null;
        }
        last = t;
        fn.apply(lastThis, lastArgs);
      } else if (!timer) {
        timer = setTimeout(function () {
          timer = null;
          last = now();
          fn.apply(lastThis, lastArgs);
        }, remaining);
      }
    };
  }

  // ---- Throttle scroll / resize / move listeners ---------------------------
  (function patchEventListeners() {
    var OrigAdd = EventTarget.prototype.addEventListener;
    var OrigRemove = EventTarget.prototype.removeEventListener;

    var SCROLL_EVENTS = {
      scroll: 80,          // ms
      touchmove: 80,
      mousemove: 80,
      wheel: 80
    };

    var RESIZE_EVENTS = {
      resize: 120,
      orientationchange: 120
    };

    function shouldThrottle(type) {
      return SCROLL_EVENTS.hasOwnProperty(type) || RESIZE_EVENTS.hasOwnProperty(type);
    }

    function getDelay(type) {
      if (SCROLL_EVENTS.hasOwnProperty(type)) return SCROLL_EVENTS[type];
      if (RESIZE_EVENTS.hasOwnProperty(type)) return RESIZE_EVENTS[type];
      return 0;
    }

    // Lưu map để removeEventListener vẫn hoạt động
    var WRAP_KEY = "__optimizedWrapper__";

    EventTarget.prototype.addEventListener = function (type, listener, options) {
      if (typeof listener !== "function" || !shouldThrottle(type)) {
        return OrigAdd.call(this, type, listener, options);
      }

      if (!listener[WRAP_KEY]) {
        var delay = getDelay(type);
        var wrapped = throttle(listener, delay);
        listener[WRAP_KEY] = wrapped;
      }

      var opts = options;
      // ép passive cho scroll / touchmove để tránh block main thread
      if (
        (type === "scroll" || type === "touchmove" || type === "wheel") &&
        (typeof options === "boolean" || options == null)
      ) {
        opts = { passive: true, capture: !!options };
      } else if (
        (type === "scroll" || type === "touchmove" || type === "wheel") &&
        typeof options === "object"
      ) {
        opts = Object.assign({}, options, { passive: true });
      }

      return OrigAdd.call(this, type, listener[WRAP_KEY] || listener, opts);
    };

    EventTarget.prototype.removeEventListener = function (type, listener, options) {
      if (listener && listener[WRAP_KEY] && shouldThrottle(type)) {
        return OrigRemove.call(this, type, listener[WRAP_KEY], options);
      }
      return OrigRemove.call(this, type, listener, options);
    };
  })();

  // ---- Soften ResizeObserver (đẩy callback vào rAF) ------------------------
  (function patchResizeObserver() {
    if (!window.ResizeObserver) return;
    var OriginalResizeObserver = window.ResizeObserver;

    function WrappedResizeObserver(callback) {
      var cb = callback;
      if (typeof cb === "function") {
        cb = function (entries, observer) {
          // đẩy vào frame để giảm reflow liên tục
          requestAnimationFrame(function () {
            callback(entries, observer);
          });
        };
      }
      return new OriginalResizeObserver(cb);
    }

    WrappedResizeObserver.prototype = OriginalResizeObserver.prototype;
    window.ResizeObserver = WrappedResizeObserver;
  })();

  // ---- Soften IntersectionObserver (throttle 100ms + rAF) ------------------
  (function patchIntersectionObserver() {
    if (!window.IntersectionObserver) return;
    var OriginalIntersectionObserver = window.IntersectionObserver;

    function WrappedIntersectionObserver(callback, options) {
      var cb = callback;

      if (typeof cb === "function") {
        var throttled = throttle(function (entries, observer) {
          requestAnimationFrame(function () {
            callback(entries, observer);
          });
        }, 100);

        cb = throttled;
      }

      return new OriginalIntersectionObserver(cb, options);
    }

    WrappedIntersectionObserver.prototype = OriginalIntersectionObserver.prototype;
    window.IntersectionObserver = WrappedIntersectionObserver;
  })();

  // ---- Optional: Debounce scroll-based "reveal" classes --------------------
  // Impact hay dùng data-attribute + scroll để reveal; throttling ở trên
  // đã giúp khá nhiều, nên ở Balanced mode ta chỉ patch nhẹ window.scroll.
  (function patchWindowScrollFlag() {
    var ticking = false;

    function onScrollLightPatch() {
      if (ticking) return;
      ticking = true;

      requestAnimationFrame(function () {
        ticking = false;
      });
    }

    window.addEventListener("scroll", onScrollLightPatch, { passive: true });
  })();

  // Debug nhẹ để kiểm tra trong console
  if (window.console && console.log) {
    console.log("[optimize.js] Balanced performance patch applied");
  }
})();
